// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__34WFm","form":"EditListingDescriptionPanel_form__2I4dK","title":"EditListingDescriptionPanel_title__LE3Gt"};